import { ADVANTAGES } from "../data/mock";

export const AdvantageSection = () => {
  return (
    <section id="advantage" className="py-24 lg:py-32 bg-[#465155]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="max-w-2xl mb-16">
          <span className="text-sm font-bold text-[#E5BD77] uppercase tracking-widest mb-3 block">
            The Asterisk Advantage
          </span>
          <h2 className="text-3xl lg:text-4xl font-bold text-white leading-tight mb-4">
            Why Leading SMEs{" "}
            <span className="text-[#E5BD77]">Choose Asterisk</span>
          </h2>
          <p className="text-[#A9B294] text-lg leading-relaxed">
            Decades of expertise, modern technology, and deep industry knowledge
            come together in every engagement.
          </p>
        </div>

        {/* Advantages Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {ADVANTAGES.map((adv, i) => {
            const Icon = adv.icon;
            return (
              <div
                key={i}
                className="group bg-white/[0.06] backdrop-blur-sm border border-white/[0.08] rounded-2xl p-6 text-center transition-all duration-400 hover:bg-white/[0.12] hover:border-white/[0.15] hover:-translate-y-1"
              >
                <div className="w-14 h-14 rounded-xl bg-[#E5BD77]/15 flex items-center justify-center mx-auto mb-5">
                  <Icon className="w-7 h-7 text-[#E5BD77]" />
                </div>
                <p className="text-sm font-semibold text-white/90 leading-snug">
                  {adv.title}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
